import { render } from "./AttachmentList.vue?vue&type=template&id=12b19b84&ts=true"
import script from "./AttachmentList.vue?vue&type=script&lang=ts"
export * from "./AttachmentList.vue?vue&type=script&lang=ts"

import "./AttachmentList.vue?vue&type=style&index=0&id=12b19b84&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__